import { Keyboard } from 'react-native';
import Input from "theme/Input";
import _ from "lodash";
import React, { useRef } from "react";
import { useStateWithCallbackLazy } from 'use-state-with-callback'
import ThemedPressable from 'components/atoms/ThemedPressable'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import isEqual from 'react-fast-compare'
import { themedInputSearchStyles } from 'styles/components/atoms/ThemedInputSearch'


const ThemedInputSearch = ({ placeholder = '', onChangeText, style = {}, initialValue = '', returnKeyType = null, onSubmitEditing = null, testID = null }) => {
	
	const inputRef = useRef();
	
	const [ value, setValue ] = useStateWithCallbackLazy(initialValue )
	
	const viewStyle = style
	
	const focusInput = () => {
		inputRef.current?.focus();
	}
	
	const clearInput = () => {
		Keyboard.dismiss();
		onChange( '' );
	}
	
	const onChange = ( value ) => {
		setValue( value, () => {
			if( _.isFunction( onChangeText ) ) {
				onChangeText( value );
			}
		} )
	}
	
	const onBlur = Keyboard.dismiss;
	
	let iconProps = {
		icon: <Icon icon={ IconSystemConstants.INPUT_SEARCH } style={ themedInputSearchStyles.icon } />,
		onPress: focusInput
	}
	
	// When we have a value, make the text 'clearable'
	if( _.size( value ) > 0 ) {
		iconProps = {
			icon: <Icon icon={ IconSystemConstants.INPUT_SEARCH } style={ themedInputSearchStyles.icon } />,
			onPress: clearInput,
		}
	}
	
	return (
		<Input
			ref={ inputRef }
			autoCorrect={ false }
			placeholder={ placeholder }
			accessoryRight={ props => {
				return (
					<ThemedPressable
						onPress={ iconProps.onPress }>

						{ iconProps.icon }
					</ThemedPressable>
				);
			} }
			value={ value }
			onChangeText={ onChange }
			onBlur={ onBlur }
			style={ viewStyle }
			returnKeyType={ returnKeyType }
			onSubmitEditing={ onSubmitEditing }
			testID={ testID }
		/>
	)
}

export default React.memo( ThemedInputSearch, isEqual );
